/**
 * Executes a function when the DOM is ready for manipulation.
 *
 * @param {Function} fn - The function to execute when DOM is ready
 *
 * @example
 * // Basic usage
 * import { ready } from './ready.js';
 * ready(() => {
 *     console.log('DOM is ready!');
 * });
 *
 * @example
 * // Initialize components when DOM is ready
 * ready(() => {
 *     registerComponent('.my-component', MyComponent);
 * });
 */

const TICK = 1;

export function ready(fn) {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        setTimeout(fn, TICK);
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}
